import type { Tone } from "@nymbl/nos2-rules";
import type { PtoStatus } from "@/lib/pto/approval-rules";

/** Status badges (spec 8.1): pending and cancel asked warning, approved success, rejected danger. */
export const STATUS_TONES: Record<PtoStatus, Tone> = {
  indraft: "neutral",
  pending: "warning",
  approved: "success",
  rejected: "danger",
  requestdelete: "warning",
};
